import customAxios from './axios';
import CONFIG from '../../config';

export const getAllEidAppoinment = (payload) => {
    return customAxios.get(CONFIG.apiURL + '/Icp/GetAllAppointmentDetails',{
        params: payload,
    }).then(res => {
        let response = res['data'];
        return response;
    });
};

export const exportCsv = (payload) => {
    return customAxios.get(CONFIG.apiURL + '/Icp/GetAppointmentDetailsExportCsv',  { responseType: 'arraybuffer',
        params: payload,
     }).then(res => {
        return res;
  });
};

export const biometricAppointmentStatusUpdate = ({ id, status }) => {
  return customAxios.post(
    `${CONFIG.apiURL}/BiometricAppointment/UpdateStatus`,null, 
    { params: {
        id,
        status,
      },
    }
  ).then(res => res.data);
};


export const paymentResendMail = ({ id, isAltermail, altermail }) => {
  return customAxios.post(
    `${CONFIG.apiURL}/Icp/PaymentResendMail`,null, 
    { params: {
        id,
        isAltermail,
        altermail
      },
    }
  ).then(res => res.data);
};


export const eidAppointmentNoteCreate = ({ eidAppointmentId, note }) => {
  return customAxios.post(
    `${CONFIG.apiURL}/EidAppointmentNote/CreateEidAppointmentNote`,null, 
    { params: {
        eidAppointmentId,
        note         
      },
    }
  ).then(res => res.data);
};





export const eidAppointmentNoteGetByAppointmentId = (eidAppointmentId) => {
    return customAxios.get(CONFIG.apiURL + '/EidAppointmentNote/GetByEidAppointmentId',{
        params: eidAppointmentId,
    }).then(res => {
        let response = res['data'];
        return response;
    });
};

export const biometricReceiptMail = ({ applicationNo, isAltermail, altermail, jobId}) => {
  return customAxios.post(
    `${CONFIG.apiURL}/BiometricAppointment/SendBiometricReceiptMail`,null, 
    { params: {
        applicationNo,
        isAltermail,
        altermail,
        jobId      
      },
    }
  ).then(res => res.data);
}

export const biometricReceiptDownload = (applicationNo, jobId) => {
  return customAxios.get(
    `${CONFIG.apiURL}/BiometricAppointment/GenerateBiometricReceipt`,
    { 
      params: {
        applicationNo,
        jobId
      },
    }
  ).then(res => res.data);
}

export const EidAppointmentEdit = ({ id, applicationNo = null, name = null, phoneNumber = null, email = null, gender = null }) => {
  return customAxios.post(
    `${CONFIG.apiURL}/Icp/EidAppointmentEdit`,
    {
      id,
      applicationNo,
      name,
      phoneNumber,
      email,
      gender
    }
  ).then(res => res.data);
}

export const EidAppointmentGetById = (id) => {
  return customAxios.get(
    `${CONFIG.apiURL}/Icp/EidAppointmentDetailsById`,
    { params: { id } }
  ).then(res => res.data);
}
